module.exports = __webpack_public_path__ + "img/logo.2d3685c3.png";